import { createBrowserRouter, Navigate } from "react-router"
import { ClientLayout } from "@/layouts/client/client-layout"
import { AdminLayout } from "@/layouts/admin/admin-layout"
import { AuthGuard } from "@/shared/components/auth-guard"
import { AdminRoute } from "@/shared/components/admin-route"

// Client pages
import DiscoveryPage from "@/client/pages/discovery/discovery-page"
import GroupDetailPage from "@/client/pages/discovery/group-detail-page"
import PostDetailPage from "@/client/pages/discovery/post-detail-page"
import UserProfilePage from "@/client/pages/discovery/user-profile-page"
import ChatPage from "@/client/pages/chat/chat-page"
import GrowthPage from "@/client/pages/growth/growth-page"
import CourseDetailPage from "@/client/pages/growth/course-detail-page"
import CoursePlayerPage from "@/client/pages/growth/course-player-page"
import AssignmentPage from "@/client/pages/growth/assignment-page"
import HackathonPage from "@/client/pages/growth/hackathon-page"
import TasksPage from "@/client/pages/tasks/tasks-page"
import TaskDetailPage from "@/client/pages/tasks/task-detail-page"
import TaskCreatePage from "@/client/pages/tasks/task-create-page"
import MePage from "@/client/pages/me/me-page"
import EditProfilePage from "@/client/pages/me/edit-profile-page"
import VerifyPage from "@/client/pages/me/verify-page"
import WalletPage from "@/client/pages/wallet/wallet-page"
import RegisterPage from "@/client/pages/auth/register-page"

// Auth pages
import LoginPage from "@/client/pages/auth/login-page"
import ForgotPasswordPage from "@/client/pages/auth/forgot-password-page"
import ResetPasswordPage from "@/client/pages/auth/reset-password-page"
import AuthCallbackPage from "@/client/pages/auth/auth-callback-page"

// Admin pages
import AdminLoginPage from "@/admin/pages/login/login-page"
import AdminDashboardPage from "@/admin/pages/dashboard/dashboard-page"
import AdminUsersPage from "@/admin/pages/users/users-page"
import AdminTasksPage from "@/admin/pages/tasks/tasks-page"
import AdminFinancePage from "@/admin/pages/finance/finance-page"
import AdminCoursesPage from "@/admin/pages/courses/courses-page"
import AdminHackathonsPage from "@/admin/pages/hackathons/hackathons-page"
import AdminCommunityPage from "@/admin/pages/community/community-page"
import AdminSettingsPage from "@/admin/pages/settings/settings-page"
import AdminLogsPage from "@/admin/pages/logs/logs-page"

// Not found
import NotFoundPage from "@/shared/pages/not-found-page"

export const router = createBrowserRouter([
  // ===== 客户端路由 (移动端H5) =====
  {
    element: <ClientLayout />,
    children: [
      // 首页重定向
      { path: "/", element: <Navigate to="/discovery" replace /> },

      // Tab0: 发现
      { path: "/discovery", element: <DiscoveryPage /> },
      { path: "/discovery/groups/:id", element: <GroupDetailPage /> },
      { path: "/discovery/posts/:id", element: <PostDetailPage /> },
      { path: "/discovery/users/:id", element: <UserProfilePage /> },
      { path: "/discovery/chat/:conversationId", element: <AuthGuard><ChatPage /></AuthGuard> },

      // Tab1: 成长（公开浏览，操作时引导登录）
      { path: "/growth", element: <GrowthPage /> },
      { path: "/growth/courses/:id", element: <GrowthPage /> },
      { path: "/growth/courses/:id/chapters/:chid", element: <AuthGuard><CoursePlayerPage /></AuthGuard> },
      { path: "/growth/assignments/:id", element: <AuthGuard><AssignmentPage /></AuthGuard> },
      { path: "/growth/hackathons/:id", element: <HackathonPage /> },

      // Tab2: 任务（公开浏览，操作时引导登录）
      { path: "/tasks", element: <TasksPage /> },
      { path: "/tasks/create", element: <AuthGuard><TaskCreatePage /></AuthGuard> },
      { path: "/tasks/:bountyId", element: <TaskDetailPage /> },

      // Tab3: 我的
      { path: "/me", element: <AuthGuard><MePage /></AuthGuard> },
      { path: "/me/edit", element: <AuthGuard><EditProfilePage /></AuthGuard> },
      { path: "/verify", element: <AuthGuard><VerifyPage /></AuthGuard> },
      { path: "/wallet", element: <AuthGuard><WalletPage /></AuthGuard> },

      // 认证
      { path: "/login", element: <LoginPage /> },
      { path: "/register", element: <RegisterPage /> },
      { path: "/forgot-password", element: <ForgotPasswordPage /> },
      { path: "/reset-password", element: <ResetPasswordPage /> },
      { path: "/auth/callback", element: <AuthCallbackPage /> },
    ],
  },

  // ===== 管理端路由 (PC后台) =====
  {
    element: <AdminLayout />,
    children: [
      // 首页重定向
      { path: "/admin", element: <Navigate to="/admin/dashboard" replace /> },

      // 登录页（不需要 AdminRoute）
      { path: "/admin/login", element: <AdminLoginPage /> },

      // 数据总览
      { path: "/admin/dashboard", element: <AdminRoute><AdminDashboardPage /></AdminRoute> },

      // 用户管理
      { path: "/admin/users", element: <AdminRoute><AdminUsersPage /></AdminRoute> },

      // 任务管理
      { path: "/admin/tasks", element: <AdminRoute><AdminTasksPage /></AdminRoute> },

      // 财务管理
      { path: "/admin/finance", element: <AdminRoute><AdminFinancePage /></AdminRoute> },

      // 课程管理
      { path: "/admin/courses", element: <AdminRoute><AdminCoursesPage /></AdminRoute> },

      // 黑客松管理
      { path: "/admin/hackathons", element: <AdminRoute><AdminHackathonsPage /></AdminRoute> },

      // 社区管理
      { path: "/admin/community", element: <AdminRoute><AdminCommunityPage /></AdminRoute> },

      // 系统设置
      { path: "/admin/settings", element: <AdminRoute><AdminSettingsPage /></AdminRoute> },

      // 操作日志
      { path: "/admin/logs", element: <AdminRoute><AdminLogsPage /></AdminRoute> },
    ],
  },

  // 404
  { path: "*", element: <NotFoundPage /> },
])